module.exports = __webpack_public_path__ + "static/media/hair6.4c124edc.png";